import React from 'react';

const s = {
  page: { padding: '2rem', maxWidth: '820px', margin: '0 auto', fontFamily: 'DM Sans, sans-serif' } as React.CSSProperties,
  card: { background: '#1a1a30', borderRadius: '16px', padding: '2rem', border: '1px solid #2a2a4a', color: '#c0c0e0', lineHeight: 1.8 } as React.CSSProperties,
  h2: { color: '#fff', margin: '1.75rem 0 0.75rem', fontSize: '1.05rem' } as React.CSSProperties,
  h3: { color: '#e0e0f0', margin: '1.25rem 0 0.5rem', fontSize: '0.95rem' } as React.CSSProperties,
  p: { marginBottom: '0.75rem' } as React.CSSProperties,
  ul: { paddingLeft: '1.5rem', marginBottom: '0.75rem' } as React.CSSProperties,
  tableWrap: { background: '#12121f', borderRadius: '10px', overflow: 'hidden', marginBottom: '1rem' } as React.CSSProperties,
  th: { padding: '0.6rem 0.75rem', textAlign: 'left' as const, color: '#fff', background: '#1F4E79', fontSize: '0.85rem' },
  td: { padding: '0.6rem 0.75rem', fontSize: '0.85rem', borderBottom: '1px solid #2a2a4a' },
  note: { background: '#2a1a00', padding: '1rem', borderRadius: '8px', borderLeft: '3px solid #d0a040', color: '#d0a040', marginBottom: '1rem' } as React.CSSProperties,
};

const Table: React.FC<{ headers: string[]; rows: string[][] }> = ({ headers, rows }) => (
  <div style={s.tableWrap}>
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
      <thead>
        <tr>{headers.map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i} style={{ background: i % 2 === 0 ? 'transparent' : '#1a1a2e' }}>
            {row.map((cell, j) => <td key={j} style={s.td}>{cell}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const Confidentialitate: React.FC = () => (
  <div style={s.page}>
    <h1 style={{ color: '#fff', marginBottom: '0.5rem' }}>🔒 Politica de Confidențialitate</h1>
    <p style={{ color: '#6060a0', fontSize: '0.85rem', marginBottom: '2rem' }}>Versiunea 1.2 | În vigoare: 03.06.2026 | Ultima actualizare: 12.06.2026</p>

    <div style={s.card}>
      <p style={s.p}>Prezenta Politică de Confidențialitate descrie modul în care SC FLEXDEV SRL, operatorul platformei Flexara, colectează, utilizează, stochează și protejează datele tale cu caracter personal, în conformitate cu Regulamentul UE 2016/679 (GDPR) și legislația română aplicabilă.</p>

      <h2 style={s.h2}>1. Cine suntem (Operatorul de date)</h2>
      <ul style={s.ul}>
        <li><strong>Denumire:</strong> SC FLEXDEV SRL</li>
        <li><strong>Țară:</strong> România</li>
        <li><strong>Email contact:</strong> <a href="mailto:contact@flexara.ro" style={{ color: '#4a4ad8' }}>contact@flexara.ro</a></li>
        <li><strong>Website:</strong> <a href="https://flexara.ro" style={{ color: '#4a4ad8' }}>flexara.ro</a></li>
      </ul>

      <h2 style={s.h2}>2. Ce date colectăm și de ce</h2>
      <h3 style={s.h3}>2.1 Date de cont (la înregistrare)</h3>
      <Table
        headers={['Categorie date', 'Exemple', 'Temei legal GDPR']}
        rows={[
          ['Date de identificare', 'Adresă email, parolă (hash)', 'Art. 6(1)(b) — executarea contractului'],
          ['Date de profil', 'Vârstă, stil viață', 'Art. 6(1)(b) — executarea contractului'],
          ['IP consimțământ (consent_ip)', 'Adresa IP la momentul acceptării termenilor', 'Art. 6(1)(c) — obligație legală (dovada consimțământului)'],
        ]}
      />
      <p style={s.p}>Parola nu este stocată niciodată în text clar — folosim hashing securizat (bcrypt).</p>

      <h3 style={s.h3}>2.2 Date de sănătate (furnizate voluntar)</h3>
      <div style={s.note}>⚠️ Aceste date sunt considerate date speciale (categorie sensibilă) conform Art. 9 GDPR. Le colectăm exclusiv pe baza consimțământului tău explicit, exprimat prin bifarea căsuței la înregistrare.</div>
      <Table
        headers={['Categorie date', 'Exemple', 'Temei legal GDPR']}
        rows={[
          ['Date de sănătate', 'Tipul problemei, zona afectată, nivel durere', 'Art. 9(2)(a) — consimțământ explicit'],
          ['Jurnal de simptome', 'Înregistrări zilnice în tracker', 'Art. 9(2)(a) — consimțământ explicit'],
          ['Planuri de recuperare', 'Exerciții generate, progres înregistrat', 'Art. 9(2)(a) — consimțământ explicit'],
        ]}
      />

      <h3 style={s.h3}>2.3 Date de utilizare</h3>
      <Table
        headers={['Categorie date', 'Exemple', 'Temei legal GDPR']}
        rows={[
          ['Istoricul conversațiilor AI', 'Mesaje trimise asistentului virtual', 'Art. 6(1)(b) — executarea contractului'],
          ['Date de activitate', 'Data ultimei accesări, funcționalități folosite', 'Art. 6(1)(f) — interes legitim'],
        ]}
      />

      <h3 style={s.h3}>2.4 Date tehnice (automat)</h3>
      <Table
        headers={['Categorie date', 'Exemple', 'Temei legal GDPR']}
        rows={[
          ['Date de acces', 'Adresă IP, tip browser, sistem de operare', 'Art. 6(1)(f) — interes legitim (securitate)'],
          ['Jurnale server', 'Timestamp-uri, erori tehnice', 'Art. 6(1)(f) — interes legitim (securitate)'],
        ]}
      />
      <p style={s.p}>Datele tehnice sunt colectate automat pentru asigurarea securității și bunei funcționări a Platformei. Nu le folosim pentru profilare sau publicitate.</p>

      <h3 style={s.h3}>2.5 Chat anonim (fără cont)</h3>
      <p style={s.p}>Dacă folosești funcționalitatea de chat fără a crea un cont, mesajele tale sunt transmise în timp real către Anthropic (furnizorul AI) și nu sunt stocate permanent pe serverele Flexara.</p>

      <h2 style={s.h2}>3. Termene de retenție</h2>
      <Table
        headers={['Categorie date', 'Termen de retenție']}
        rows={[
          ['Date de cont', 'Pe durata existenței contului + 30 de zile după ștergere'],
          ['Date de sănătate', 'Pe durata existenței contului + 30 de zile după ștergere'],
          ['Istoricul chat', 'Pe durata existenței contului + 30 de zile după ștergere'],
          ['Date tehnice (loguri)', 'Maximum 90 de zile'],
          ['IP consimțământ (consent_ip)', 'Maximum 90 de zile — nullificat automat după 90 de zile de la înregistrare'],
          ['Date conturi inactive', '24 de luni de inactivitate, apoi ștergere (cu notificare)'],
          ['Date financiare (Stripe)', 'Conform obligațiilor legale contabile (10 ani)'],
          ['Backup-uri', 'Maximum 30 de zile'],
        ]}
      />

      <h2 style={s.h2}>4. Cu cine împărtășim datele tale</h2>
      <p style={s.p}>Nu vindem datele tale personale. Le împărtășim doar cu următorii destinatari, strict în măsura necesară:</p>
      <Table
        headers={['Furnizor', 'Serviciu', 'Locație procesare', 'Garanții GDPR']}
        rows={[
          ['Anthropic', 'Procesare AI (asistent virtual)', 'SUA', 'Clauze Contractuale Standard (SCC)'],
          ['Stripe', 'Procesarea plăților', 'SUA / UE', 'Clauze Contractuale Standard (SCC)'],
          ['Hetzner AG', 'Infrastructură server', 'Germania (UE)', 'DPA disponibil la hetzner.com/legal/privacy'],
          ['Mailgun (Sinch Email)', 'Email tranzacțional (adrese de email)', 'EU — Germania', 'DPA incorporat în Terms of Service Sinch Email, Secțiunea 4.3'],
        ]}
      />
      <p style={s.p}><strong>Anthropic PBC (SUA)</strong> — furnizor AI, procesează conversațiile utilizatorilor conform Data Processing Addendum incorporat în Commercial Terms of Service. Mai multe detalii: <a href="https://www.anthropic.com/legal/commercial-terms" style={{ color: '#4a4ad8' }} target="_blank" rel="noreferrer">https://www.anthropic.com/legal/commercial-terms</a>.</p>
      <p style={s.p}>Toți furnizorii sunt obligați contractual să proceseze datele tale exclusiv conform instrucțiunilor noastre și să aplice măsuri adecvate de securitate.</p>

      <h2 style={s.h2}>5. Transferuri internaționale de date</h2>
      <p style={s.p}>Anthropic și Stripe au sediul în Statele Unite ale Americii. Transferul datelor tale se realizează cu garanții adecvate, în conformitate cu Art. 46 GDPR, prin utilizarea Clauzelor Contractuale Standard aprobate de Comisia Europeană. Poți solicita o copie a acestor garanții scriindu-ne la <a href="mailto:contact@flexara.ro" style={{ color: '#4a4ad8' }}>contact@flexara.ro</a>.</p>

      <h2 style={s.h2}>6. Drepturile tale</h2>
      <ul style={s.ul}>
        <li>✅ <strong>Dreptul de acces (Art. 15 GDPR)</strong> — poți solicita o copie a tuturor datelor tale. Disponibil din Profil &gt; GDPR &gt; Export Date (format JSON).</li>
        <li>✅ <strong>Dreptul la rectificare (Art. 16 GDPR)</strong> — poți corecta datele inexacte din secțiunea Profil.</li>
        <li>✅ <strong>Dreptul la ștergere (Art. 17 GDPR)</strong> — ștergere completă din Profil &gt; GDPR &gt; Ștergere Cont. Procesare în maximum 30 de zile.</li>
        <li>✅ <strong>Dreptul la portabilitate (Art. 20 GDPR)</strong> — date exportabile în format JSON din Profil &gt; GDPR &gt; Export Date.</li>
        <li>✅ <strong>Dreptul de opoziție (Art. 21 GDPR)</strong> — poți retrage oricând consimțământul pentru comunicările comerciale.</li>
        <li>✅ <strong>Dreptul la restricționarea prelucrării (Art. 18 GDPR)</strong> — contactează-ne la <a href="mailto:contact@flexara.ro" style={{ color: '#4a4ad8' }}>contact@flexara.ro</a>.</li>
        <li>✅ <strong>Dreptul de a depune o plângere</strong> — la ANSPDCP, <a href="https://www.dataprotection.ro" style={{ color: '#4a4ad8' }} target="_blank" rel="noreferrer">www.dataprotection.ro</a>, B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București.</li>
      </ul>
      <p style={s.p}>Răspundem la orice solicitare în maximum 30 de zile calendaristice.</p>

      <h2 style={s.h2}>7. Securitatea datelor tale</h2>
      <ul style={s.ul}>
        <li><strong>Criptare date sensibile:</strong> datele de sănătate sunt stocate criptat (pgcrypto — pgp_sym_encrypt).</li>
        <li><strong>Transport securizat:</strong> toate comunicațiile sunt criptate prin HTTPS/TLS.</li>
        <li><strong>Parole:</strong> stocate exclusiv ca hash (bcrypt), niciodată în text clar.</li>
        <li><strong>Autentificare:</strong> token JWT cu expirare automată, validat la fiecare cerere.</li>
        <li><strong>Acces restricționat:</strong> doar personalul autorizat are acces la datele utilizatorilor.</li>
        <li><strong>Backup:</strong> backup zilnic automat, păstrat maximum 30 de zile.</li>
        <li><strong>Rate limiting:</strong> limitare automată a încercărilor de autentificare împotriva atacurilor brute-force.</li>
      </ul>

      <h2 style={s.h2}>8. Decizii automate și profilare</h2>
      <p style={s.p}>Planurile de exerciții și recomandările generate de asistentul AI sunt produse automat pe baza informațiilor pe care le furnizezi. Aceste procese nu constituie profilare cu efecte juridice semnificative în sensul Art. 22 GDPR — reprezintă exclusiv personalizarea unui serviciu educațional pe care l-ai solicitat explicit.</p>

      <h2 style={s.h2}>9. Lista de așteptare (Waitlist)</h2>
      <p style={s.p}>Dacă te-ai înscris pe lista de așteptare Flexara înainte de lansarea platformei, prelucrăm datele tale în condițiile de mai jos.</p>
      <Table
        headers={['Categorie date', 'Detalii', 'Temei legal GDPR']}
        rows={[
          ['Adresă de email', 'Furnizată voluntar la înscriere', 'Art. 6(1)(a) — consimțământ explicit'],
          ['Timestamp înscriere', 'Data și ora înscrierii pe waitlist', 'Art. 6(1)(a) — consimțământ explicit'],
        ]}
      />
      <ul style={s.ul}>
        <li><strong>Perioadă de retenție:</strong> 24 de luni de la data înscrierii sau până la ștergerea manuală la cerere.</li>
        <li><strong>Transfer către terți:</strong> datele din waitlist nu sunt transferate către niciun terț.</li>
        <li><strong>Dreptul la ștergere:</strong> poți solicita oricând eliminarea adresei tale de email scriind la <a href="mailto:contact@flexara.ro" style={{ color: '#4a4ad8' }}>contact@flexara.ro</a>.</li>
      </ul>

      <h2 style={s.h2}>10. Cookie-uri</h2>
      <p style={s.p}>Informații detaliate privind cookie-urile utilizate de Flexara sunt disponibile în <a href="/cookies" style={{ color: '#4a4ad8' }}>Politica de Cookies</a>.</p>

      <h2 style={s.h2}>11. Modificări ale Politicii de Confidențialitate</h2>
      <p style={s.p}>Modificările semnificative vor fi comunicate prin email cu cel puțin 30 de zile înainte și prin notificare vizibilă în Platformă. Versiunea actualizată va fi publicată la flexara.ro/confidentialitate.</p>

      <h2 style={s.h2}>12. Contact</h2>
      <ul style={s.ul}>
        <li>Email: <a href="mailto:contact@flexara.ro" style={{ color: '#4a4ad8' }}>contact@flexara.ro</a></li>
        <li>Website: <a href="https://flexara.ro" style={{ color: '#4a4ad8' }}>flexara.ro</a></li>
        <li>Operator: SC FLEXDEV SRL, România</li>
        <li>Autoritate de supraveghere: ANSPDCP — <a href="https://www.dataprotection.ro" style={{ color: '#4a4ad8' }} target="_blank" rel="noreferrer">www.dataprotection.ro</a></li>
      </ul>

    </div>
  </div>
);

export default Confidentialitate;
